import {
  Authenticator,
  Image,
  Text,
  View,
  CheckboxField,
} from "@aws-amplify/ui-react";
import { PropsWithChildren } from "react";

import { useFeatureFlagEnabled } from "posthog-js/react";
import styles from "./amplify-authenticator.module.scss";

type LoginMechanisms = Parameters<typeof Authenticator>[0]["loginMechanisms"];

const Header = () => (
  <View className={styles.authHeader}>
    <Image alt="Claimable" src="/images/logo/logo_black_large.svg" />
  </View>
);

const Footer = () => (
  <Text variation="tertiary">{"© 2024 All rights reserved."}</Text>
);

const ForcePasswordAgreeToTermsAndPrivacyPolicy = () => (
  <>
    <Authenticator.ForceNewPassword.FormFields />
    <CheckboxField
      name="custom:agreeToTerms"
      value="agree"
      isRequired
      label={
        <>
          {"I agree to the"}{" "}
          <a
            href="https://www.getclaimable.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {"Terms of Service"}
          </a>{" "}
          {"and"}{" "}
          <a
            href="https://www.getclaimable.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {"Privacy Policy"}
          </a>
        </>
      }
    />
  </>
);

const SignUpHeader = () => (
  <h1 className={styles.signInHeader}>{"Create account"}</h1>
);

const SignInHeader = () => <h1 className={styles.signInHeader}>{"Sign in"}</h1>;

const ClaimableAuthenticator = ({ children }: PropsWithChildren) => {
  const loginMechanisms: LoginMechanisms = ["email"];
  const isSelfServeProviderSignupEnabled = useFeatureFlagEnabled(
    "self-serve-provider-signup",
  );
  const themeComponents = {
    Header,
    Footer,
    ForceNewPassword: {
      FormFields: ForcePasswordAgreeToTermsAndPrivacyPolicy,
    },
    SignIn: {
      Header: SignInHeader,
    },
    SignUp: {
      Header: SignUpHeader,
    },
  };

  return (
    <div className={styles.claimableAuthenticator}>
      <Authenticator
        loginMechanisms={loginMechanisms}
        components={themeComponents}
        hideSignUp={!isSelfServeProviderSignupEnabled}
      >
        {children}
      </Authenticator>
    </div>
  );
};

export default ClaimableAuthenticator;
